import React, { Fragment, useEffect, useState } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import TeamComponent from "../Components/About/TeamComponent";

/* teams images */
import t1 from "../Assets/img/pages/agniwa.jpg";
import t2 from "../Assets/img/pages/ananya.jpg";
import t3 from "../Assets/img/pages/Chavan.jpg";
import t4 from "../Assets/img/pages/geeta.jpg";
import t5 from "../Assets/img/pages/karthik.jpg";
import t6 from "../Assets/img/pages/minu.jpg";
import t7 from "../Assets/img/pages/sanjay.jpg";
import t8 from "../Assets/img/pages/tushar.jpg";

/* company images */
//import acuity from "../Assets/img/comapny-logos/acuity.jpg";
import adobe from "../Assets/img/comapny-logos/adobe.jpg";
//import bcg from "../Assets/img/comapny-logos/bcg.jpg";
//import carelon from "../Assets/img/comapny-logos/carelon.jpg";
//import factset from "../Assets/img/comapny-logos/factset.jpg";
//import kpmg from "../Assets/img/comapny-logos/kpmg.jpg";
import LogoComponent from "../Components/About/LogoComponent";
import {
  useGetCompanyListQuery,
  useGetPageDataQuery,
} from "../Store/api/CommonApi";
import { Link } from "react-router-dom";

// const logos = [
//   { img: acuity, title: "acuity", link: "/" },
//   { img: adobe, title: "adobe", link: "/" },
//   { img: bcg, title: "bcg", link: "/" },
//   { img: carelon, title: "carelon", link: "/" },
//   { img: factset, title: "factset", link: "/" },
//   { img: kpmg, title: "kpmg", link: "/" },
//   { img: acuity, title: "acuity", link: "/" },
//   { img: adobe, title: "adobe", link: "/" },
// ];

const teams = [
  {
    img: t1,
    title: "Agniva",
    position: "Manager, Hiring & Operations",
    stitle: "(He/Him)",
    link: "/",
  },
  {
    img: t2,
    title: "Ananya",
    position: "Associate Director",
    stitle: "(She/Her)",
    link: "/",
  },
  {
    img: t3,
    title: "Chavan",
    position: "Recruiter",
    stitle: "(He/Him)",
    link: "/",
  },
  {
    img: t4,
    title: "Geeta G",
    position: "Sr.Manager, Hiring & Partnerships",
    stitle: "(She/Her)",
    link: "/",
  },
  {
    img: t5,
    title: "Karthik TK",
    position: "Sr. Recruitment Specialist",
    stitle: "(He/Him)",
    link: "/",
  },
  {
    img: t6,
    title: "Minu M",
    position: "Sourcing Specialist",
    stitle: "(She/Her)",
    link: "/",
  },
  {
    img: t7,
    title: "Sanjay",
    position: "Sr.Manager, Hiring & Partnerships",
    stitle: "(He/Him)",
    link: "/",
  },
  {
    img: t8,
    title: "Tushar P",
    position: "Recruitment Specialist",
    stitle: "(He/Him)",
    link: "/",
  },
];

export default function About() {
  const { data } = useGetPageDataQuery("about-us");
  const companyApi = useGetCompanyListQuery();
  const [companies, setCompanies] = useState([]);
  const [path, setPath] = useState("");

  useEffect(() => {
    if (companyApi?.data) {
      setCompanies(companyApi?.data?.data);
      setPath(companyApi?.data?.path);

      setTimeout(() => {
        window
          .$(".customer-logos")
          .not(".slick-initialized")
          .slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 1500,
            arrows: false,
            dots: false,
            loop: false,
            pauseOnHover: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 4,
                },
              },
              {
                breakpoint: 520,
                settings: {
                  slidesToShow: 3,
                },
              },
            ],
          });
      }, 500);
    }
  }, [companyApi?.data]);

  useEffect(() => {
    window.$(".active-review-carusel").owlCarousel({
      items: 2,
      margin: 30,
      autoplay: true,
      loop: true,
      dots: true,
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        768: {
          items: 2,
        },
      },
    });
  }, []);

  return (
    <Fragment>
      <PageBannerComponent
        title={data?.data?.heading}
        image={data?.data?.image}
      />

      {data?.data?.content !== "" && (
        <div className="container mt-4">
          <p dangerouslySetInnerHTML={{ __html: data?.data?.content }}></p>
        </div>
      )}

      {/* Start service Area */}
      {/* <section className="service-area section-gap" id="service">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-10 pb-40 header-text">
              <h1>Why Choose Us</h1>
              {/* <p> Who are in extremely love with eco friendly system. </p> }
              <p>
                <b>Inclusive Opportunities:</b>{" "}
                <i>
                  Access jobs in companies championing inclusivity and embracing
                  LGBT+ Talent.
                </i>
              </p>
              <p>
                <b>Career Growth:</b>{" "}
                <i>
                  Discover roles that align with your aspirations and support
                  professional development.
                </i>
              </p>
              <p>
                <b>Empowered Community:</b>{" "}
                <i>
                  Join a network driving change, where your identity and
                  potential are celebrated.
                </i>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-user" /> &nbsp; 100 Queer Internship
                  Program
                </h5>
                <br />
                <br />
                <p>
                  <i>
                    Kickstart your career with paid internships designed for
                    LGBT+ students. Gain hands-on experience and build your
                    professional skills at inclusive workplaces.
                  </i>
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                  <ul>
                    <li>
                      Access verified opportunities tailored for queer students.
                    </li>
                    <li>Build valuable experience while earning a stipend.</li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-license" /> &nbsp; Masterclass
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Skilling &amp;
                  Hiring LGBT+ Talent
                </h5>
                <br />
                <p>
                  <i>
                    Attend engaging sessions designed to prepare and inspire
                    LGBT+ job seekers (lateral & freshers). These Masterclasses
                    cover essential workplace skills including soft skills and
                    insights to thrive in inclusive workplaces.
                  </i>
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                  <ul>
                    <li>
                      Learn from expert-led sessions on tech or non-tech topics.
                    </li>
                    <li>
                      Gain access to opportunities with inclusive employers.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-phone" /> &nbsp; Resume Building
                  Sessions
                </h5>
                <br />
                <br />
                <p>
                  <i>
                    Enhance your job applications with expert guidance on
                    creating impactful resumes that showcase your skills and
                    achievements effectively.
                  </i>
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                  <ul>
                    <li>
                      Learn to tailor your resume for inclusive industries and
                      roles.
                    </li>
                    <li>Highlight your unique strengths and experiences.</li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-rocket" /> &nbsp; Queer Career
                  Conversations
                </h5>
                <br />
                <br />
                <p>
                  <i>
                    Unlock Your Potential with Expert Tips for Professional
                    Growth
                  </i>
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                  <ul>
                    <li>
                      Gain valuable insights and industry knowledge to stay
                      ahead in your career.
                    </li>
                    <li>
                      Receive personalized guidance to navigate your
                      professional journey with confidence.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-bubble" /> &nbsp; Ace Your Next
                  Interview with
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Confidence!
                </h5>
                <br />
                <p>
                  <i>Own Your Story, Land Your Dream Job</i>
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                  <ul>
                    <li>
                      Master essential interview skills with expert insights and
                      proven strategies.
                    </li>
                    <li>
                      Build confidence and authenticity to showcase your true
                      potential to employers.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-diamond" /> &nbsp; Pride Connections
                </h5>
                <br />
                <br />
                <p>
                  <i>
                    Meet & Have Coffee with the Pride Circle Hiring Team every
                    first Thursday of the Month
                  </i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Start service Area */}
      <section className="service-area section-gap" id="service">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-9 pb-40 header-text">
              <h1>Why Choose Us</h1>
              <p>
                <strong>Inclusive Opportunities</strong>
                <br />
                <i>
                  Access jobs in companies championing inclusivity and embracing
                  women professionals and LGBT+ talent.
                </i>
              </p>
              <p>
                <strong>Career Growth</strong>
                <br />
                <i>
                  Discover roles that align with your aspirations, values, and
                  long-term professional development goals.
                </i>
              </p>
              <p>
                <strong>Empowered Community</strong>
                <br />
                <i>
                  Join a growing network of changemakers where your identity,
                  voice, and potential are celebrated.
                </i>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-user" /> &nbsp; 100 Queer Internship
                  Program
                </h5>
                <br />
                <p>
                  Kickstart your career with paid internships designed for LGBT+
                  students. Gain hands-on experience and build your professional
                  skills at inclusive workplaces.
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                </p>
                <ul>
                  <li>
                    Access verified opportunities tailored for queer students.
                  </li>
                  <li>Build valuable experience while earning a stipend.</li>
                </ul>
                <p />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-user" /> &nbsp; SheRISE Internship
                  Program
                </h5>
                <br />
                <p>
                  Kickstart your professional journey with paid internships
                  created exclusively for{" "}
                  <b>women students and early-career professionals</b>. Gain
                  real-world experience, build industry-relevant skills, and
                  work with organizations committed to <b>inclusion</b>.
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                </p>
                <ul>
                  <li>
                    Gain <b>hands-on experience</b> through impactful projects
                  </li>
                  <li>Build valuable experience while earning a stipend.</li>
                </ul>
                <p />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-license" /> &nbsp; Masterclass Series
                  (Skilling & Hiring)
                </h5>
                <br />
                <p>
                  Engaging sessions designed to prepare women and LGBT+ job
                  seekers (lateral & freshers). These sessions cover soft
                  skills, technical skills needed to thrive in workplaces.
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                </p>
                <ul>
                  <li>
                    Learn directly from experts on career-readiness, tech, and
                    non-tech topics.
                  </li>
                  <li>
                    Get access to opportunities with leading inclusive
                    employers.
                  </li>
                </ul>
                <p />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-phone" /> &nbsp; Resume Building
                  Sessions
                </h5>
                <br />
                <p>
                  Enhance your job application with expert guidance on crafting
                  impactful resumes and cover letters that truly represent your
                  potential.
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                </p>
                <ul>
                  <li>
                    Learn to tailor your resume for inclusive industries and
                    roles.
                  </li>
                  <li>Highlight your unique strengths and experiences.</li>
                </ul>
                <p />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-rocket" /> &nbsp; Career
                  Conversations
                </h5>
                <br />
                <p>
                  Access expert-led career guidance sessions designed to help
                  you make informed professional choices.
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                </p>
                <ul>
                  <li>
                    Gain valuable insights and industry knowledge to stay ahead
                    in your career.
                  </li>
                  <li>
                    Receive personalized guidance to navigate your professional
                    journey with confidence.
                  </li>
                </ul>
                <p />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-bubble" /> &nbsp; Ace Your Job
                  Interview Own Your Story. Land Your Dream Job.
                </h5>
                <br />
                <p>
                  <i>
                    A confidence-building space for women and LGBT+
                    professionals to master interview preparation.
                  </i>
                </p>
                <p>
                  <b>Why Participate?</b>
                  <br />
                </p>
                <ul>
                  <li>
                    Master essential interview skills with expert insights and
                    proven strategies.
                  </li>
                  <br />
                  <li>
                    Build confidence and authenticity to showcase your true
                    potential to employers.
                  </li>
                </ul>
                <p />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h5>
                  <span className="lnr lnr-diamond" /> &nbsp; Brew & Build
                </h5>
                <br />
                <p>
                  <i>
                    Your monthly Career Connect Over Coffee with the Pride
                    Circle Hiring Team every third Thursday of the month.
                  </i>
                </p>
                <ul>
                  <li>
                    Strengthen your confidence and readiness for real-world
                    interviews.
                  </li>
                  <br />
                  <li>
                    Ask questions, seek career advice, get personalized feedback
                    from the Pride Circle Hiring Team.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End service Area */}

      {/* End service Area */}
      {/* Start feature Area */}
      {/* <section className="feature-area">
        <div className="container-fluid">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-3 feat-img no-padding">
              <img
                className="img-fluid"
                src={require("../Assets/img/pages/f1.a.jpg")}
                alt=""
              />
            </div>
            <div className="col-lg-3 no-padding feat-txt">
              <h6 className="text-uppercase text-white mb-4">
                Unlock opportunities with organizations that prioritize
                Diversity, Equity, and Inclusion.
              </h6>
              <p className="text-white" style={{ fontSize: "14px" }}>
                <i>
                  Build a career &amp; thrive authentically
                  <br />
                  where your unique identity and skills
                  <br />
                  are truly recognized and valued.
                </i>
              </p>
            </div>
            <div className="col-lg-3 feat-img no-padding">
              <img
                className="img-fluid"
                src={require("../Assets/img/pages/f1.jpg")}
                alt=""
              />
            </div>
            <div className="col-lg-3 no-padding feat-txt">
              <h6 className="text-uppercase text-white mb-4">
                Sense of Belonging
              </h6>
              <br />
              <p className="text-white" style={{ fontSize: "14px" }}>
                <i>
                  Feeling safe, welcomed,
                  <br />
                  and a sense of belonging are <br />
                  essential for anyone's well-being.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section> */}

      <section className="feature-area">
        <div className="container-fluid">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-3 feat-img no-padding">
              <img
                className="img-fluid"
                src={require("../Assets/img/pages/f1.b.jpg")}
                alt=""
              />
            </div>
            <div className="col-lg-3 no-padding feat-txt">
              <h1 style={{ fontSize: 17 }}>
                Unlock Opportunities with Organizations that Prioritize
                Inclusion & Belonging
              </h1>
              <p style={{ color: "white" }}>
                Unlock opportunities with organizations that prioritize
                Inclusion & Belonging Build a career & thrive authentically
                where your unique identity and skills are truly recognized and
                valued.
              </p>
            </div>
            <div className="col-lg-3 feat-img no-padding">
              <img
                className="img-fluid"
                src={require("../Assets/img/pages/f1.jpg")}
                alt=""
              />
            </div>
            <div className="col-lg-3 no-padding feat-txt">
              <h1 style={{ fontSize: 17 }}>
                Sense of Inclusion &amp; Belonging
              </h1>
              <p style={{ color: "white" }}>
                Feeling safe, welcomed, and a sense of belonging are essential
                for anyone's well-being.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* End feature Area */}
      {/* Start team Area */}
      {/* <section className="team-area section-gap" id="team">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content pb-70 col-lg-8">
              <div className="title text-center">
                <h1 className="mb-10">
                  Meet the Team Behind Inclusive Hiring!
                </h1>
                <p>Connecting Talent with Opportunity</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center d-flex">
            {teams.length > 0 &&
              teams.map((v, i) => <TeamComponent item={v} key={i} />)}
          </div>
        </div>
      </section>*/}
      {/* End team Area */}
      {/* Start callto-action Area */}
      <section className="callto-action-area section-gap" id="join">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content col-lg-9">
              <div className="title text-center">
                <h1 className="mb-10 text-white">Join the Movement</h1>
                <h3 className="mb-10 text-white">
                  Grow your career with Pride Circle - and be part of the
                  change.
                </h3>
                <p className="text-white">
                  Join a team that’s driving meaningful impact, empowering women
                  and LGBT+ professionals to thrive in workplaces that celebrate
                  authenticity, inclusion, and growth.'
                  <br />
                  Explore opportunities with us today.
                </p>
                <Link
                  className="primary-btn"
                  //href="mailto:contact@thepridecircle.com"
                  to="/login"
                >
                  Apply Here
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End calto-action Area */}
      {/* Start testimonial Area */}
      <section className="testimonial-area section-gap" id="review">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content pb-60 col-lg-8">
              <div className="title text-center">
                <h1 className="mb-10">Testimonials</h1>
                <p>
                  <b>
                    <u>Company Testimonials</u>
                  </b>
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="active-review-carusel">
              <div className="single-review">
                {/* <img src="img/r1.png" alt="" />
                <div className="title d-flex flex-row">
                  <h4>Sauravi (Citi Bank)</h4>
                  <div className="star">
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star" />{" "}
                    <span className="fa fa-star" />{" "}
                  </div>
                </div> */}
                <div>
                  <p>
                    <span
                      style={{ fontSize: "12px", textDecoration: "italic" }}
                    >
                      "I am writing with an overflowing sense of gratitude and
                      appreciation for the outstanding support and invaluable
                      assistance your team has extended to Siemens Healthineers
                      in fulfilling our training and hiring needs in the journey
                      of becoming a truly diverse & inclusive company. From the
                      outset of our collaboration, your team demonstrated an
                      exceptional level of professionalism, passion, and
                      expertise………..As we move forward, I am excited about the
                      prospect of continuing this incredible partnership. Your
                      team's guidance and support are integral to our journey
                      toward creating an even more inclusive and vibrant
                      workplace at Siemens Healthineers…"
                    </span>
                    <br />
                    <br />
                    - Ajay Krishnankutty (He/Him)
                    <br />
                    Head of Talent Acquisition - APJ Region, Siemens
                    Healthineers
                  </p>
                </div>
              </div>
              <div className="single-review">
                {/* <img src="img/r2.png" alt="" />
                <div className="title d-flex flex-row">
                  <h4>Candidate (Name withheld on Request)</h4>
                  <div className="star">
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star" />{" "}
                    <span className="fa fa-star" />{" "}
                    <span className="fa fa-star" />{" "}
                  </div>
                </div> */}
                <div>
                  <p>
                    <span
                      style={{ fontSize: "12px", textDecoration: "italic" }}
                    >
                      <i>
                        "It's an absolute treat working along with Pride Circle
                        on several hiring and inclusion initiatives. The team is
                        knowledgeable, professional, and truly dedicated to
                        finding the right candidates for our organization who
                        not only bring the necessary skills and experience but
                        also align with our values. Their understanding of the
                        unique needs and challenges faced by LGBTQ+ individuals
                        in the job market is unparalleled, and they have been
                        instrumental in helping us build a more inclusive and
                        welcoming workplace."
                      </i>
                    </span>
                    <br />
                    <br />
                    - Zoya (They/Them)
                    <br />
                    Manager - D&I, Employer Branding, Godrej Properties
                  </p>
                </div>
              </div>
              <div className="single-review">
                {/* <img src="img/r2.png" alt="" />
                <div className="title d-flex flex-row">
                  <h4>Candidate (Name withheld on Request)</h4>
                  <div className="star">
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star" />{" "}
                    <span className="fa fa-star" />{" "}
                    <span className="fa fa-star" />{" "}
                  </div>
                </div> */}
                <div>
                  <p>
                    <span
                      style={{ fontSize: "12px", textDecoration: "italic" }}
                    >
                      <i>
                        "Acquity Knowledge Partners is elated to have
                        participated in the RISE Job Fair, a Flagship event for
                        the LGBTQ+ Community hosted by Pride Circle. Our digital
                        booth provided us with an opportunity to engage with
                        over 2000 professionals. A heartfelt thank you to all
                        those who stopped by our booth. We had the pleasure of
                        engaging in meaningful dialogues with numerous
                        candidates and encountered a host of enthusiastic
                        professionals eager to create their careers with us…"
                      </i>
                    </span>
                    <br />
                    <br />
                    - Vimal Singh
                    <br />
                    Director- Global Talent Acquisition, Acuity Knowledge
                    Partners
                  </p>
                </div>
              </div>
              {/* <div className="single-review">
                <img src="img/r1.png" alt="" />
                <div className="title d-flex flex-row">
                  <h4>lorem ipusm</h4>
                  <div className="star">
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star" />{" "}
                    <span className="fa fa-star" />{" "}
                  </div>
                </div>
                <p>
                  Accessories Here you can find the best computer accessory for
                  your laptop, monitor, printer, scanner, speaker. Here you can
                  find the best computer accessory for your laptop, monitor,
                  printer, scanner, speaker.{" "}
                </p>
              </div>
              <div className="single-review">
                <img src="img/r2.png" alt="" />
                <div className="title d-flex flex-row">
                  <h4>lorem ipusm</h4>
                  <div className="star">
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star checked" />{" "}
                    <span className="fa fa-star" />{" "}
                    <span className="fa fa-star" />{" "}
                    <span className="fa fa-star" />{" "}
                  </div>
                </div>
                <p>
                  Accessories Here you can find the best computer accessory for
                  your laptop, monitor, printer, scanner, speaker. Here you can
                  find the best computer accessory for your laptop, monitor,
                  printer, scanner, speaker.{" "}
                </p>
              </div> */}
            </div>
          </div>

          <div className="row d-flex justify-content-center mt-5">
            <div className="menu-content pb-40 col-lg-8">
              <div className="title text-center">
                <p>
                  <b>
                    <u>Candidate Testimonials</u>
                  </b>
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="active-review-carusel">
              <div className="single-review">
                <div>
                  <p>
                    <span style={{ fontSize: "12px" }}>
                      <i>
                        "I'm deeply grateful to the Pride Circle recruitment team for supporting me in securing a role at NatWest. While I recognize my own skills and abilities, I know this wouldn’t have been possible without their unwavering guidance. This opportunity has transformed my career journey, and I'll always remain thankful to Pride Circle’s Hiring Team for being part of it."
                      </i>
                    </span>
                    <br />
                    <br />- Name Withheld (He/Him)
                  </p>
                </div>
              </div>
              <div className="single-review">
                <div>
                  <p>
                    <span style={{ fontSize: "12px" }}>
                      <i>
                        "I recently joined Future Generali India Insurance as a Trainee - Health Claim, and I owe a huge thanks to Pride Circle. The recruitment process was smooth, transparent, and affirming, with constant support at every step. I truly appreciate Pride Circle Hiring Team’s commitment to creating inclusive workplaces and helping candidates like me find the right opportunities."
                      </i>
                    </span>
                    <br />
                    <br />- Name Withheld (They/Them)
                  </p>
                </div>
              </div>
              <div className="single-review">
                <div>
                  <p>
                    <span style={{ fontSize: "12px" }}>
                      <i>
                        "As a fresh graduate, securing an apprenticeship with Standard Chartered has been a big milestone. Pride Circle’s Hiring Team kept me informed and supported me through the entire process, making my journey seamless. I’m grateful for their guidance in helping me land this role and start my career on the right note."
                      </i>
                    </span>
                    <br />
                    <br />- Name Withheld (He/Him)
                  </p>
                </div>
              </div>
              <div className="single-review">
                <div>
                  <p>
                    <span style={{ fontSize: "12px" }}>
                      <i>
                        "Pride Circle has been a pivotal part of my career journey - helping me find a role that aligns with both my skills and aspirations. The entire process, from application to offer, was smooth, supportive, and affirming. Pride Circle's Hiring Team is more than just a job portal; it's a community that uplifts and empowers. Thank you for helping me take this exciting next step in my professional life."
                      </i>
                    </span>
                    <br />
                    <br />- Aparna (She/Her)
                  </p>
                </div>
              </div>
              <div className="single-review">
                <div>
                  <p>
                    <span style={{ fontSize: "12px" }}>
                      <i>
                        "As a transman, receiving an offer from my dream company has been a proud milestone in my journey. This achievement wouldn’t have been possible without the constant encouragement and guidance of Pride Circle’s Hiring Team. Their support not only helped me secure this opportunity but also gave me the confidence to step forward with hope. I truly value the work Pride Circle does to empower individuals like me."
                      </i>
                    </span>
                    <br />
                    <br />- Harshit (They/Them)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End testimonial Area */}
      <section className="testimonial-area mb-50">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content pb-60 col-lg-8">
              <div className="title text-center">
                <h3 className="mb-10">
                  Partnering with Companies Committed to Inclusion
                </h3>
                <p>Driving Diversity, Empowering Talent, Creating Impact!</p>
              </div>
            </div>
          </div>
          <div className="customer-logos slider">
            {companies.length > 0 &&
              companies.map((v, i) => (
                <LogoComponent item={v} img={adobe} key={i} path={path} />
              ))}
            {/* <div className="slide">
              <img src="img/comapny-logos/adobe.jpg" alt="" />
            </div>
            <div className="slide">
              <img src="img/comapny-logos/bcg.jpg" alt="" />
            </div>
            <div className="slide">
              <img src="img/comapny-logos/carelon.jpg" alt="" />
            </div>
            <div className="slide">
              <img src="img/comapny-logos/factset.jpg" alt="" />
            </div>
            <div className="slide">
              <img src="img/comapny-logos/kpmg.jpg" alt="" />
            </div>
            <div className="slide">
              <img src="img/comapny-logos/adobe.jpg" alt="" />
            </div>
            <div className="slide">
              <img src="img/comapny-logos/carelon.jpg" alt="" />
            </div> */}
          </div>
        </div>
      </section>
    </Fragment>
  );
}
